class ProductGallery extends HTMLElement {
    constructor() {
        super();
        this.swiperInstance = null;
        this.slideIndex = 0;
    }

    connectedCallback() {
        // Initialize swiper when component is connected
        this.initSwiper();

    }

    initSwiper() {
        const swiperContainer = this.querySelector('swiper-container.product-gallery-swiper');
        const thumbnailContainer = this.querySelector('swiper-container.product-gallery-thumbnails') || null;
        
        if (!swiperContainer) return;

        // Wait for swiper custom element to be defined and ensure elements are upgraded
        if (customElements.get('swiper-container')) {
            // Add a small delay to ensure custom elements are fully upgraded
            setTimeout(() => {
                this.setupSwiper(swiperContainer, thumbnailContainer);
            }, 10);
        } else {
            customElements.whenDefined('swiper-container').then(() => {
                // Add a small delay to ensure custom elements are fully upgraded
                setTimeout(() => {
                    this.setupSwiper(swiperContainer, thumbnailContainer);
                }, 10);
            });
        }

        document.addEventListener('updateSelectedVariant', (event) => {
            if (event?.detail?.id) {
                this.setToVariant(event.detail.id);
            }
        });

        //if there's a variant id in the url, set to that variant
        const urlParams = new URLSearchParams(window.location.search);
        const variantId = urlParams.get('variant');
        if (variantId) {
            this.setToVariant(variantId);
        }
    }

    setToVariant(variantId) {
        //check if there's a swiper slide that has the data-variant-id attribute set to the variantId
        const swiperContainer = this.querySelector('swiper-container.product-gallery-swiper');
        const slides = Array.from(swiperContainer.querySelectorAll('swiper-slide'));
        const slide = slides.find(slide => slide.dataset.variantId === String(variantId));
        if (slide) {
            const realIndex = parseInt(slide.dataset.swiperSlideIndex, 10) + 1;
            const currentIndex = slides.indexOf(slide);
            swiperContainer.swiper.slideTo(currentIndex);
        }
    }

    setupSwiper(swiperContainer, thumbnailContainer) {
        // Check if there's only one slide
        const slides = swiperContainer.querySelectorAll('swiper-slide');
        
        let swiperConfig = {
            slidesPerView: 'auto',
            spaceBetween: 12,
            navigation: {
                enabled: false
            },
            loop: slides.length > 2 ? true : false,
            centeredSlides: true,
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    loop: true,
                    navigation: {
                        enabled: true
                    }
                }
            },
            on: {
                init: () => {
                    this.classList.remove('opacity-0', 'max-h-80');
                }
            }
        };

        let thumbnailConfig = {
			direction: 'horizontal',
			slidesPerView: 'auto',
            spaceBetween: 0,
            on: {
                init: () => {
                    if (thumbnailContainer) {
                        thumbnailContainer.classList.remove('not-loaded');
                    }
                }
            }
		};

        if (!this.classList.contains('quick-add-gallery')) {
            thumbnailConfig.breakpoints = {
				1280: {
					direction: 'vertical',
                    slidesPerView: 'auto',
                    spaceBetween: 0
				},
                1536: {
                    slidesPerView: 'auto',
                    spaceBetween: 0,
                    direction: 'vertical',
                },
			};
        }

        // Initialize thumbnail container first if it exists
        if (thumbnailContainer) {
            // Ensure the swiper-container is properly defined and has initialize method
            if (typeof thumbnailContainer.initialize === 'function') {
                Object.assign(thumbnailContainer, thumbnailConfig);
                thumbnailContainer.initialize();
                
                // Set up thumbs after thumbnail container is initialized
                swiperConfig.thumbs = {
                    swiper: thumbnailContainer,
                };
            } else {
                console.warn('Thumbnail container does not have initialize method, skipping thumbs');
            }
        }

        // Initialize main swiper container
        if (typeof swiperContainer.initialize === 'function') {
            Object.assign(swiperContainer, swiperConfig);
            swiperContainer.initialize();
        } else {
            console.error('Swiper container does not have initialize method');
        }

        const modalWrapper = this.closest('quick-add-modal');
        if (modalWrapper) {
            if (modalWrapper.checkAndAdjustOverflow) {
                setTimeout(() => {
                    modalWrapper.checkAndAdjustOverflow();
                }, 10);
            }
        }
    }

    disconnectedCallback() {
        this.cleanup();
    }

    cleanup() {
        // Clean up main swiper
        const swiperContainer = this.querySelector('swiper-container.product-gallery-swiper');
        if (swiperContainer && swiperContainer.swiper) {
            swiperContainer.swiper.destroy(true, true);
        }

        // Clean up thumbnail swiper
        const thumbnailContainer = this.querySelector('swiper-container.product-gallery-thumbnails');
        if (thumbnailContainer && thumbnailContainer.swiper) {
            thumbnailContainer.swiper.destroy(true, true);
        }

        // Clean up any stored instance
        if (this.swiperInstance) {
            this.swiperInstance.destroy();
            this.swiperInstance = null;
        }
    }
}

customElements.define('product-gallery', ProductGallery);
